/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/FrameDebouncedModel.js");
var extender = Model.makeExtender;
var par = require("par");
const pageNames = require("../../constants/PageNames.json");

var BACK_MAP = {
	"contact_settings": ["owncontactsettings:trigger:clear"],
	"contactprofile": ["managedaccount:trigger:close"],
	"groupmessaging": ["groupchat:trigger:close"],
	"invite": ["accountinvites:trigger:accountinvites:reset"],
	"manage_request": ["managementrequests:trigger:search:clear"],
	"managed_atouchaway": ["managedatouchaway:trigger:reset"],
	"managed_simplified": ["managedsimplified:trigger:reset"],
	"managed_bracelet": ["managedbracelet:trigger:reset"],
	"managed_contacts": ["search:trigger:clear", "managedcontactrequests:trigger:search:clear", "managedcontacts:trigger:reset", "managedaccountinvites:trigger:reset"],
	"managed_contact_requests": ["managedcontactrequests:trigger:search:clear"],
	"managed_forms": ["managedforms:trigger:reset"],
	"managed_manager_requests": ["search:trigger:clear", "managedmanagerrequests:trigger:refresh"],
	"managed_managers_permissions": ["collapsibles:trigger:reset", "managedmanagerpermissions:trigger:reset"],
	"managed_managers": ["managedmanagers:trigger:reset", "managedmanagerinvites:trigger:reset"],
	"managed_metrics_list": ["managedmetrics:trigger:reset"],
	"managed_picture": ["managedpreferences:trigger:picture:update_reset"],
	"managed_urgency": ["managedurgencycontacts:trigger:reset"],
	"messaging": ["messages:trigger:close"],
	"preferences": ["preferences:trigger:preferences:success_reset"],
	"reminders": ["managedreminders:trigger:reset"],
	"request": ["search:trigger:clear"],
	"massmessage": ["search:trigger:clear"],
	"managed_workflow": ["managedworkflow:trigger:reset"],
	"managed_workflow_actions": ["activemanagedworkflow:trigger:reset"],
	"managed_workflow_create": ["managedcreateworkflow:trigger:close", "managedcontacts:trigger:reset"],
	"managed_workflow_edit": ["managedcontacts:trigger:reset"],
	"managedbloodsugar": ["managedbloodsugar:trigger:reset"],
	"managedweight": ["managedweight:trigger:reset"],
	"managedbloodpressure": ["managedbloodpressure:trigger:reset"],
	"managedbodytemperature": ["managedbodytemperature:trigger:reset"],
	"managedbloodoxygen": ["managedbloodoxygen:trigger:reset"],
	"managedactivity": ["managedactivity:trigger:reset"],
	"managedoverview": ["managedoverview:trigger:reset"],
	"managedcustomindicator": ["managedcustomindicator:trigger:reset"],
	"bloodsugar": ["bloodsugar:trigger:reset"],
	"weight": ["weight:trigger:reset"],
	"bloodpressure": ["bloodpressure:trigger:reset"],
	"bodytemperature": ["bodytemperature:trigger:reset"],
	"bloodoxygen": ["bloodoxygen:trigger:reset"],
	"activity": ["activity:trigger:reset"],
	"customindicator": ["customindicator:trigger:reset"],
	"overview": ["overview:trigger:reset"],
	"resourceview": ["managedresources:trigger:closeresource"],
	"ownresourceview": ["ownresources:trigger:closeresource"],
	"managed_group_form_submissions": ["managedgroupformsubmissions:trigger:clear"],
	"managed_devices": ["manageddevices:trigger:reset"],
	"org_user_list": ["orgusers:trigger:reset", "activegroupmanagegroup:trigger:clear"],
	"devices_add": ["owndevices:trigger:cancel"],
	"devices_update": ["owndevices:trigger:cancel"],
	"managed_devices_add": ["manageddevices:trigger:cancel"],
	"managed_devices_update": ["manageddevices:trigger:cancel"],
	"livechat_message": ["livechatmessages:trigger:reset"],
	"livechat": ["livechatsessions:trigger:reset", "livechatsessionpending:trigger:reset", "livechatsessionhistory:trigger:reset"],
	"view_user_group_form_submission": ["managedactivegroupformsubmission:trigger:reset"]
};

/**
 * This is the main model for desktop applications. It holds all the state necessary for the app.
 * @type {Model}
 */
module.exports = Model({
	name: "desktop",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_history: null,
	set_page: set_page,
	back_page: back_page,
	go_home: go_home,
});

function init() {
	// Set up page history
	this._history = [];

	/*
	 * This is the initial state. This is what things look like initially
	 */
	this.push({
		activemanagegroup: null, // The manage group that's being viewed
		activegroupformsubmission: {},
		activeownformsubmission: {},
		activeownformprepopulate: null,
		autoreply: {}, // The autoreply. A string shows that if set to auto reply mode
		availability: {}, // The availability of all the people getting tracked
		banner: [], // Array of Banner information
		calling: {}, // The state of the calling model
		callredirector: {}, // The current state of the call redirector UI
		callinputswitcher: {}, // The current state of the call input switcher UI
		collapsibles: {},	// The current state of collapsible/expandable items in the pages
		conferenceinviter: {}, // The current state of the conference cal linviter modal
		config: this.config, // The config passed in during creation
		contactprofile: {}, //The current profile that is being viewed
		contacts: {}, // Map with contacts and managed users. Is the state of AllContacts
		cropper: {}, // The settings for the cropper's display
		devicepermissions: {},
		fileviewer: {},
		focused: true, // Whether the app is in focus or not
		groups: {}, // Map with groups
		groupchat: {}, // The state of Groupchat,
		groupformlist: {},
		groupformsubmissions: {},
		groupgroupedmessages: {},
		groupedmessages: {},
		homepage: {}, // The current homepage state
		loading: false, // whenther the app is loading managed users' availability
		localization: {}, // The current localization file,
		magnifying: false,
		manage: {}, // The management model state, contains everything related to it
		managedaccount: {}, //The current state of an account being remotely managed.
		managegroups: [], // The list of manage groups we're in
		messages: {}, // The state of Messages
		missed: {}, // Map of missed calls and messages from specific users
		myhealth: {},
		myhealthdevice: false,
		customindicator: [],
		customindicatorslist: [],
		myreminders: {},
		nologin: {}, // The nologin account information
		orggroup: null,
		online: true, // Whether there is a connection to the server or not
		options: {}, // The Options model state
		orientation: null, // The Orientation model state
		page: "home", // What the main page is currently showing
		personal: {}, // The current person's personal data
		preferences: {}, // The preferences that are being edited
		personalpicture: {}, // The state for editing your personal profile picture
		requests: {}, // The incoming/outgoing contact requests,
		reverify: {
			sent: false,
			message: ""
		}, ///keeps track if verification has been resent
		saving: false, // whether the app is saving sth
		schedules: {}, // the current schedule and whether modifying or not
		schedulemaker: {}, // The current task being modified for automated on/offline status
		search: [], // The search model
		allsections: {},
		newsections: {},
		ownformlist: {},
		ownformsubmissions: {},
		tab: 0, // The current tab to display in the home page
		trialwizard: {},
		toast: "", // init toast message empty
		usernotifications: {}, // state of all the user's notifications
		outdated: false,
		videoposition: "", // The position of the local video stream
		audiooutput: null, // The currently selected audio output device, if available
		careplan: {}, // State of currently displayed careplan section
		passwordtimeout: false,
		size: {},
		feedbackmodal: null,
		formsources: {},
		focusstate: null,
		hangupreply: false,
		workflowactions: [],
		workflowaction: false,
		status: {},
		callgroups: [],
		callgroupscalling: {},
		incall: {},
		callgroupsmembers: [],
		workflowdefinition: [],
		ownresources: {},
		orgusers: [],
		orguserinvites: [],
		usercreation: null,
		stafflist: [],
		owndevices: [],
		livechatsessions: {},
		livechatsessionpending: {},
		livechatgroups: [],
		livechatsessionhistory: {},
		activelivechatsession: {},
		activelivechatgroup: {},
		livechatmessages: {},
		livechatgroupedmessages: {},
		livechatlatestmessages: {},
		livechatmissedmessage: {},
		workflowautoview: false,
		license: false,
		privacypolicy: false,
		owncontactsettings: {},
		contactsettings: {},
		workflowexternals: {},
		groupsettings: {},
		activegroupmanagegroup: {},
		accountswitch: {},
		atouchawaysettings: {},
		groupmanagegroups: [],
		finishaccount: {},
		allContacts: [],
		ownformorderedlist: [],
		devicefollowup: {},
		audiooutputselector: {},
		people: {},
		accountdeletion: {}
	});
}

/**
 * Sets the current page to be displayed
 * @param {String} page One of "calling", "home", "messaging"
 */
function set_page(page) {
	if (typeof page !== "string")
		page = page.page;

	if (!page) return;

	var old_page = this.data.page;

	if (page === old_page) return;

	if (old_page)
		this._history.push(old_page);

	this.extend({
		page: page
	});

}

/**
 * Goes back one page in the page history
 * Goes to "home" if nothing is in history
 */
function back_page() {
	var state = this.data;
	var current_page = state.page;
	var managedAccount = state.manage.open; // profile page open status
	var payload = {};

	var autoBack = BACK_MAP[current_page];
	if(autoBack)
		autoBack.forEach(function (event) {
			this.emit(event, {});
		}, this);

	if(managedAccount) {
		payload = {
			who: state?.manage?.account?._id,
		}
	}

	if (current_page === "contactprofile" && managedAccount){
		this.emit("managedaccount:trigger:close", {});
		this.emit("managedcareplansection:trigger:reset");
	}
	if(current_page.indexOf("careplan_") === 0)
		this.emit("managedcareplanexpander:trigger:contract");
	if(current_page.indexOf("_edit") !== -1)
		this.emit("managedcareplansectioneditor:trigger:reset");

	var page = this._history.pop();
	if(current_page === "contactprofile" && (!page || page === "home"))
		this.emit("contactprofile:trigger:clear");
	if (!page) {
		return this.go_home();
	}

	while (current_page === page && page)
		page = this._history.pop();

	this.extend({
		page: page
	});

	const pageName = pageNames.backward[page];
	pageName !== "SKIP" && this.emit("usermetrics:trigger:track", pageNames.backward[page] || `navigate back to ${page} page (automatically generated)`, payload);
}

/**
 * Goes to the "home" page.
 * If in a call, goes to calling page,
 * else it's contacts
 */
function go_home() {
	var current_page = this.data.page;
	var page = "home";

	if(current_page === "contactprofile")
		this.emit("contactprofile:trigger:clear");

	this._history = [];

	this.extend({
		page: page
	});

	this.emit("usermetrics:trigger:track", "navigate to home page (desktop)", {
		page
	});
}

function listeners() {
	return {
		"activemanagegroup:updated": extender("activemanagegroup"),
		"accountinvites:sent": go_home,
		"allcontacts:removecontact": go_home,
		"allcontacts:removing": par(set_page, "removecontact"),
		"allcontacts:toggledcontacts": handle_options_opened,
		"allcontacts:updated": extender("contacts"),
		"app:button:back": back_page,
		"audiooutputselector:updated": extender("audiooutput"),
		"autoreply:updated": extender("autoreply"),
		"availability:updated": extender("availability"),
		"banner:navigating": set_page,
		"banner:updated": extender("banner"),
		"blocking:unblock": back_page,
		"buzz:state:busy": make_sound_trigger("busy"),
		"meetings:start": make_sound_trigger("incoming", true),
		"meetings:stop": stop_sound,
		"buzz:state:calling": make_sound_trigger("outgoing", true),
		"buzz:state:connecting": stop_sound,
		"buzz:state:idle": stop_sound,
		"buzz:state:receiving": make_sound_trigger("incoming", true),
		"calling:updated": handle_calling_update,
		"callinputswitcher:updated": extender("callinputswitcher"),
		"callmagnifier:updated": extender("magnifying"),
		"callredirector:updated": extender("callredirector"),
		"careplan:updated": extender("careplan"),
		"careplan:viewing": handle_mycareplan_open,
		"collapsibles:updated": extender("collapsibles"),
		"conferenceinviter:updated": extender("conferenceinviter"),
		"contactprofile:openedprofile": par(set_page, "contactprofile"),
		"contactprofile:updated": extender("contactprofile"),
		"fallinvalidator:updated": extender("fallinvalidator"),
		"devicepermissions:updated": extender("devicepermissions"),
		"fileviewer:updated": extender("fileviewer"),
		"groups:updated": extender("groups"),
		"groupgroupedmessages:updated": extender("groupgroupedmessages"),
		"groupedmessages:updated": extender("groupedmessages"),
		"homepage:updated": extender("homepage"),
		"loading:updated": extender("loading"),
		"localization:updated": handle_localization_update,
		"logoutconfirmmodal:updated": extender("logoutconfirmmodal"),
		"managedatouchaway:viewing": par(set_page, "managed_atouchaway"),
		"managedsimplified:viewing": par(set_page, "managed_simplified"),
		"managedbracelet:viewing": par(set_page, "managed_bracelet"),
		"managedcareplansection:viewing": handle_careplan_open,
		"managedcareplansectioneditor:editing:finished": back_page,
		"managedcareplansectioneditor:editing": handle_careplan_edit_open,
		"managedcontactrequests:requested": back_page,
		"managedcontacts:viewing": par(set_page, "managed_contacts"),
		"managedforms:cancelled": back_page,
		"managedforms:closed": back_page,
		"managedforms:creating": par(set_page, "managed_forms_creation"),
		"managedforms:opened": par(set_page, "managed_forms_view"),
		"managedforms:removed": back_page,
		"formsources:updated": extender("formsources"),
		"managedforms:updating:closed": back_page,
		"managedforms:updating": par(set_page, "managed_forms_update"),
		"managedforms:viewing": par(set_page, "managed_forms"),
		"managedmanagerpermissions:viewing": par(set_page, "managed_managers_permissions"),
		"managedmanagerrequests:added": back_page,
		"managedmanagerrequests:invited": back_page,
		"managedmanagerrequests:done": back_page,
		"managedmanagerrequests:viewing": par(set_page, "managed_manager_requests"),
		"managedmanagers:viewing": par(set_page, "managed_managers"),
		"managedmetrics:viewing": par(set_page, "managed_metrics_list"),
		"managedpreferences:viewing": par(set_page, "managed_preferences"),
		"managedprofilepicture:cancelled": back_page,
		"managedprofilepicture:started": par(set_page, "managed_picture_crop"),
		"managedprofilepicture:success": back_page,
		"managedremindermaker:close": back_page,
		"managedremindermaker:open": par(set_page, "managed_reminder_maker"),
		"managedreminders:removed": back_page,
		"managedreminders:removing": par(set_page, "remove_reminder"),
		"managedreminders:viewing": par(set_page, "reminders"),
		"managedurgencycontacts:viewing": par(set_page, "managed_urgency"),
		"managedgroupformsubmissions:viewing": par(set_page, "managed_group_form_submissions"),
		"managedactivegroupformsubmission:creating": par(set_page, "create_user_group_form_submission"),
		"managedactivegroupformsubmission:viewing": par(set_page, "view_user_group_form_submission"),
		"managedactivegroupformsubmission:updating": par(set_page, "update_user_group_form_submission"),
		"managedactivegroupformsubmission:cancelled": back_page,
		"managedactivegroupformsubmission:finished": back_page,
		"groupforms:viewing": par(set_page, "groupforms"),
		"groupformsubmissions:viewing": par(set_page, "group_form_submissions"),
		"activegroupformsubmission:updated": extender("activegroupformsubmission"),
		"activegroupformsubmission:viewing": par(set_page, "active_group_form_submission"),
		"activegroupformsubmission:creating": par(set_page, "create_group_form_submission"),
		"activegroupformsubmission:updating": par(set_page, "update_group_form_submission"),
		"activegroupformsubmission:cancelled": back_page,
		"activegroupformsubmission:finished": back_page,
		"activeownformsubmission:updated": extender("activeownformsubmission"),
		"activeownformsubmission:viewing": par(set_page, "active_own_form_submission"),
		"activeownformsubmission:creating": par(set_page, "create_own_form_submission"),
		"activeownformsubmission:updating": par(set_page, "update_own_form_submission"),
		"activeownformsubmission:cancelled": back_page,
		"activeownformsubmission:finished": back_page,
		"activeownformprepopulate:updated": extender("activeownformprepopulate"),
		"management:managedcontactremoved": back_page,
		"management:managedcontactremoving": par(set_page, "managedcontact_remove"),
		"management:managedmanagersremoved": back_page,
		"management:managedmanagersremoving": par(set_page, "managedmanagers_remove"),
		"management:managementremoved": go_home,
		"management:removemanagement": par(set_page, "management_remove"),
		"management:updated": extender("manage"),
		"managementrequests:added": back_page,
		"managementrequests:denied": back_page,
		"managementrequests:denying": par(set_page, "remove_management_request"),
		"messages:opened": par(set_page, "messaging"),
		"messages:updated": extender("messages"),
		"groupchat:opened": par(set_page, "groupmessaging"),
		"groupchat:updated": extender("groupchat"),
		"groupchat:closed": back_page,
		"groupchat:adding": par(set_page, "groupchat_add"),
		"groupchat:creating": par(set_page, "groupadd"),
		"groupformlist:updated": extender("groupformlist"),
		"groupformsubmissions:updated": extender("groupformsubmissions"),
		"missed:updated": extender("missed"),
		"nologin:updated": extender("nologin"),
		"online:updated": extender("online"),
		"options:trunkopened": handle_options_opened,
		"options:updated": extender("options"),
		"orientation:updated": extender("orientation"),
		"passwordtimeout:updated": extender("passwordtimeout"),
		"personal:updated": handle_personal_update,
		"personalprofilepicture:cancelled": back_page,
		"personalprofilepicture:started": par(set_page, "profile_picture_crop"),
		"personalprofilepicture:success": back_page,
		"personalprofilepicture:updated": extender("personalpicture"),
		"preferences:updated": extender("preferences"),
		"preferences:viewing": par(set_page, "preferences"),
		"profilesection:updated": extender("profilesection"),
		"requests:added": back_page,
		"requests:denied": back_page,
		"requests:denying": par(set_page, "remove_contact_request"),
		"requests:updated": extender("requests"),
		"save:updated": extender("saving"),
		"schedulemaker:updated": extender("schedulemaker"),
		"schedules:updated": extender("schedules"),
		"screenfocus:updated": extender("focused"),
		"search:updated": extender("search"),
		"size:updated": extender("size"),
		"ownformlist:updated": extender("ownformlist"),
		"ownformsubmissions:updated": extender("ownformsubmissions"),
		"ownformsubmissions:viewing": par(set_page, "own_form_submissions"),
		"toast:updated": extender("toast"),
		"trialwizard:updated": extender("trialwizard"),
		"usernotifications:updated": extender("usernotifications"),
		"updatefetcher:updated": extender("outdated"),
		"videoposition:updated": extender("videoposition"),
		"wanderinvalidator:updated": extender("wanderinvalidator"),
		"managedactivity:viewing": par(set_page, "managedactivity"),
		"managedbloodsugar:viewing": par(set_page, "managedbloodsugar"),
		"managedbloodpressure:viewing": par(set_page, "managedbloodpressure"),
		"managedweight:viewing": par(set_page, "managedweight"),
		"managedoverview:viewing": par(set_page, "managedoverview"),
		"managedbloodoxygen:viewing": par(set_page, "managedbloodoxygen"),
		"managedbodytemperature:viewing": par(set_page, "managedbodytemperature"),
		"managedcustomindicator:viewing": par(set_page, "managedcustomindicator"),
		"managedcustomindicator:deleted": handleManagedCustomIndicatorDeleted,
		"focusstate:updated": extender("focusstate"),
		"hangupreply:updated": extender("hangupreply"),
		"activeworkflowaction:updated": Model.makeExtender("workflowaction"),
		"workflowactions:updated": Model.makeExtender("workflowactions"),
		"managedworkflow:viewing": par(set_page, "managed_workflow"),
		"activemanagedworkflow:viewing": par(set_page, "managed_workflow_actions"),
		"managedcreateworkflow:creating": par(set_page, "managed_workflow_create"),
		"managedcreateworkflow:finished": back_page,
		"managededitingworkflow:editing": par(set_page, "managed_workflow_edit"),
		"managededitingworkflow:finished": back_page,
		"orggroup:updated": Model.makeExtender("orggroup"),
		"bloodoxygen:viewing": par(set_page, "mybloodoxygen"),
		"bodytemperature:viewing": par(set_page, "mybodytemperature"),
		"weight:viewing": par(set_page, "myweight"),
		"bloodpressure:viewing": par(set_page, "mybloodpressure"),
		"bloodsugar:viewing": par(set_page, "mybloodsugar"),
		"activity:viewing": par(set_page, "myactivity"),
		"overview:viewing": par(set_page, "myoverview"),
		"myhealth:updated": extender("myhealth"),
		"myhealthdevice:updated": extender("myhealthdevice"),
		"customindicator:viewing": par(set_page, "mycustomindicator"),
		"customindicator:deleted": handleCustomIndicatorDeleted,
		"customindicatorslist:updated": extender("customindicatorslist"),
		"myreminders:updated": extender("myreminders"),
		"ownreminders:viewing": par(set_page, "myreminders"),
		"ownreminders:removed": back_page,
		"ownreminders:removing": par(set_page, "remove_reminder"),
		"ownremindermaker:close": back_page,
		"ownremindermaker:open": par(set_page, "own_reminder_maker"),
		"ownactivereminder:updated": Model.makeExtender("reminders"),
		"remindershistory:alert": make_sound_trigger("alert"),
		"ownactivereminder:active": par(set_page, "own_reminder_view"),
		"ownactivereminder:hidden": back_page,
		"feedbackmodal:updated": extender("feedbackmodal"),
		"sectionupdates:updated": extender("allsections"),
		"newsectionupdates:updated": extender("newsections"),
		"ownstatus:updated": extender("status"),
		"callgroups:updated": extender("callgroups"),
		"incall:updated": extender("incall"),
		"callgroupscalling:updated": extender("callgroupscalling"),
		"callgroupsmembers:updated": extender("callgroupsmembers"),
		"workflowdefinitions:updated": extender("workflowdefinitions"),
		"ownresources:updated": extender("ownresources"),
		"ownresources:open": par(set_page, "ownresources"),
		"ownresources:detail": par(set_page, "ownresourceview"),
		"ownresources:close": back_page,
		"managedresources:open": par(set_page, "managed_resources"),
		"managedresources:detail": par(set_page, "managed_resource_view"),
		"managedresources:editing": par(set_page, "managed_resources_edit"),
		"managedresources:finished": back_page,
		"ownformsubmissions:form:deleted": handle_form_deleted,
		"managedgroupformsubmissions:form:deleted": handle_managed_form_deleted,
		"orgusers:viewing": par(set_page, "org_user_list"),
		"orgusers:updated": extender("orgusers"),
		"stafflist:updated": extender("stafflist"),
		"usercreation:updated": extender("usercreation"),
		"usercreation:viewing": par(set_page, "org_user_creation"),
		"usercreation:cancel": back_page,
		"orguserinvites:updated": extender("orguserinvites"),
		"owndevices:updated": extender("owndevices"),
		"owndevices:viewing": par(set_page, "devices"),
		"owndevices:adding": par(set_page, "devices_add"),
		"owndevices:updating": par(set_page, "devices_update"),
		"owndevices:finished": back_page,
		"manageddevices:adding": par(set_page, "managed_devices_add"),
		"manageddevices:updating": par(set_page, "managed_devices_update"),
		"manageddevices:viewing": par(set_page, "managed_devices"),
		"manageddevices:finished": back_page,
		"activelivechatgroup:updated": extender("activelivechatgroup"),
		"activelivechatsession:updated": extender("activelivechatsession"),
		"livechatgroups:updated": extender("livechatgroups"),
		"livechatsessions:updated": extender("livechatsessions"),
		"livechatsessionhistory:updated": extender("livechatsessionhistory"),
		"livechatsessionpending:updated": extender("livechatsessionpending"),
		"activelivechatgroup:viewing": par(set_page, "livechat"),
		"activelivechatsession:viewing": par(set_page, "livechat_message"),
		"livechatmessages:updated": extender("livechatmessages"),
		"livechatgroupedmessages:updated": extender("livechatgroupedmessages"),
		"livechatlatestmessages:updated": extender("livechatlatestmessages"),
		"livechatmissedmessage:updated": extender("livechatmissedmessage"),
		"activelivechatgroup:close": handle_group_deleted,
		"workflowactionautoviewermobile:updated": extender("workflowautoview"),
		"license:updated": extender("license"),
		"privacypolicy:updated": extender("privacypolicy"),
		"owncontactsettings:updated": extender("owncontactsettings"),
		"contactsettings:updated": extender("contactsettings"),
		"owncontactsettings:viewing": par(set_page, "contact_settings"),
		"owncontactsettings:finish": back_page,
		"workflowexternals:updated": extender("workflowexternals"),
		"managedaccountinvites:sent": back_page,
		"managegroups:updated": extender("managegroups"),
		"groupmanagegroups:updated": extender("groupmanagegroups"),
		"orgautologout:updated": extender("orgautologout"),
		"orgmultifactor:updated": extender("orgmultifactor"),
		"groupsettings:updated": extender("groupsettings"),
		"activegroupmanagegroup:updated": extender("activegroupmanagegroup"),
		"accountswitcher:updated": extender("accountswitch"),
		"atouchawaysettings:updated": extender("atouchawaysettings"),
		"atouchawaysettings:hideforms": handle_hide_forms,
		"atouchawaysettings:hidemyhealth": handle_hide_myhealth,
		"finishaccount:updated": extender("finishaccount"),
		"contacts:updated": extender("allContacts"),
		"ownformorderedlist:updated": extender("ownformorderedlist"),
		"devicefollowup:updated": extender("devicefollowup"),
		"people:updated": extender("people"),
		"accountdeletion:updated": extender("accountdeletion")
	};
}

function triggers() {
	return {
		"page": handle_trigger_page,
		"page:back": back_page,
		"page:home": go_home,
		"page:replace": no_history_page,
		"reverify": handle_trigger_reverify,
		"tab": handle_trigger_tab
	};
}

function no_history_page(page) {
	if (typeof page !== "string")
		page = page.page;

	if (!page) return;

	this.extend({
		page: page
	});

}

function make_sound_trigger(sound, loop) {
	return function () {
		this.emit("sounds:trigger:play", {
			sound: sound,
			loop: loop
		});
	};
}

function stop_sound() {
	this.emit("sounds:trigger:stop", {});
}

/**
 * Handles changes in localization. Updates `localization` state.
 * @param  {Object} data The state of the Localization model. Contains `localization` map.
 */
function handle_localization_update(data) {
	this.extend({
		localization: data.localization
	});
}

/**
 * Handles changes in calling. If calls are being made, switches page to calling.
 * When calls go idle, go back to contacts
 * @param  {Object} calling The state of calling
 */
function handle_calling_update(calling) {
	var update = {
		calling: calling
	};
	this.extend(update);

	var state = calling.state;
	var available = this.data.personal.available;

	if ((state === "calling") || (state === "receiving" && available) || (state === "busy"))
		this.set_page("calling");
	else if (state === "idle" && this.data.page === "calling")
		this.back_page();
}

/**
 * Handles trigger for changing the page
 * @param  {Object} data Data containing the `page` to switch to.
 */
function handle_trigger_page(data) {
	var page = data.page;
	var payload = data.payload;

	this.set_page(page);

	const pageName = pageNames.forward[page];
	
	pageName !== "SKIP" && this.emit("usermetrics:trigger:track", pageNames.forward[page] || `navigate to ${page} page (autogenerated event)`, payload);
}

/**
 * Triggered by the AccountInvites model dispatching an event saying it has
 * successfully sent out an invite
 */

function handle_personal_update(personal) {
	this.extend({
		personal: personal,
		reverify: {
			sent: false,
			message: ""
		}
	});
}

function handle_trigger_reverify() {
	this.api.auth.verify.resend();
	this.extend({
		reverify: {
			sent: true,
			message: "ae_verification_resend_success"
		}
	});
	this.emit("usermetrics:trigger:track", "request new verification email");
}

function handle_trigger_tab(data) {
	var page = data.page;
	this.extend({
		tab: parseInt(page) || 0
	});

	this.emit("search:trigger:clear");
}

function handle_options_opened() {
	this.emit("search:trigger:clear");
}

function handle_careplan_open(data) {
	var section = data.section;
	this.set_page("careplan_" + section);
}

function handle_careplan_edit_open(data) {
	var section = data.section;
	this.set_page("careplan_" + section.toLowerCase() + "_edit");
}

function handle_mycareplan_open(data) {
	var section = data.section;
	this.set_page("my_careplan_" + section);
}

function handle_form_deleted(){
	this.set_page("my_health");
}

function handle_managed_form_deleted(){
	var history = this._history;
	var historyLength = history.length;
	if(history[historyLength - 1] === "managed_group_form_submissions")
		this._history.pop();

	this.extend({
		page: "contactprofile"
	});
}

function handle_group_deleted(){
	var page = this.data.page;
	if(page === "livechat_message")
		this.back_page();
	this.back_page();
}

function handle_hide_myhealth(){
	var state = this.data;
	var current_page = state.page;

	var autoBack = BACK_MAP[current_page];
	if(autoBack){
		autoBack.forEach(function (event) {
			this.emit(event, {});
		}, this);
	}
	this.go_home();
}

function handle_hide_forms(){
	this.go_home();
}

function handleManagedCustomIndicatorDeleted() {
	if (this.data.page === "managedcustomindicator") {
		this.extend({
			page: "contactprofile"
		});
		this.emit("newreading:trigger:hide");
	}
}

function handleCustomIndicatorDeleted() {
	if (this.data.page === "customindicator") {
		this.extend({
			page: "myhealth"
		});
		this.emit("newreading:trigger:hide");
	}
}